import React from "react";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "../../assets/icons/close.svg";
import infoIcon from "../../assets/icons/info-circle.svg";
function WarningModal({
  headingTitle = "",
  descriptionText = "",
  isOpen = false,
  onCloseHandler = () => console.log("No onclose handler provided"),
  isProceedBtnDisable = false,
}) {
  return (
    <Modal
      show={isOpen}
      dialogClassName="new-design-v1"
      centered
      onHide={onCloseHandler}
    >
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <div>
          <h4 className="modal-title">{headingTitle}</h4>
        </div>
        <div className="d-flex align-items-center">
          <img
            className="close"
            src={CloseIcon}
            alt="closeIcon"
            onClick={() => onCloseHandler()}
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="excel-upload-popup-content">
          <div className="d-flex align-items-center">
            <div>
              <img src={infoIcon} alt="info" />
            </div>
            <div className="ml-4 font-size-20 font-weight-510 text-color-020617">
              Attention
            </div>
          </div>
          <div className="font-size-14 text-color-020617 line-height-28">
            {descriptionText}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          className="secondary-button mr-4"
          style={{ maxWidth: "90px" }}
          onClick={() => onCloseHandler()}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="primary-button"
          style={{ maxWidth: "100px" }}
          onClick={() => onCloseHandler(true)}
          disabled={isProceedBtnDisable}
        >
          Proceed
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default WarningModal;
